import axios from "axios";
import { API_BASE_URL } from "./BaseURL";



export const createBill = async (billData) => {
  console.log(billData)
  return await axios.post(`${API_BASE_URL}/bills`, billData);
};

export const getAllBills = async (params = {}) => {
  try {

    
  
    const response = await axios.get(`${API_BASE_URL}/bills`, { params });
    
 
    
    return response;
  } catch (error) {
   
    throw error;
  }
};

export const getBillById = async (id) => {
  return await axios.get(`${API_BASE_URL}/bills/${id}`);
};


export const getBillByRef = async (refNo) => {
  return await axios.get(`${API_BASE_URL}/bills/ref/${refNo}`);
};


export const updateBill = async (id, data) => {
  return await axios.put(`${API_BASE_URL}/bills/update/${id}`, data);
};


export const deleteBill = async (id) => {
  return await axios.delete(`${API_BASE_URL}/bills/${id}`);
};

export const getAllSimpleNewCounts = async()=>{
  return await axios.get(`${API_BASE_URL}/bills/counts`)
}
